import '../chart-element';

export default (ctx, html) => html`
  <chart-element type="bar"
    .chartData="${ctx.chartData}"
    .chartOptions="${ctx.chartOptions}"
    .chartPlugins="${ctx.chartPlugins}"
    .width="${ctx.graphWidth}"
    .height="${ctx.graphHeight}"></chart-element>
`;
